import React, { useEffect, useState } from 'react';
import { Box, Input } from 'theme-ui';
import { sendResetEmail } from '../../../redux/feature/forgotPasswordSlice';
import { setLoginChildPageName } from '../../../redux/feature/loginCredSlice';
import { useDispatch, useSelector } from 'react-redux';
import '../login.scss';
import { ClipLoader } from 'react-spinners';

const ResetPassword = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [showError, setShowError] = useState(false);
  const { isLoading } = useSelector(
    (state) => state?.forgotPasswordSlice?.sendResetEmail
  );

  const handleResetClick = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !emailRegex.test(email)) {
      setShowError(true);
    } else {
      dispatch(sendResetEmail({ email }));
      setShowError(false);
      setEmail('');
    }
  };

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleInputFocus = () => {
    setShowError(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      document.getElementById('forgot-password-button').click();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <Box sx={{ fontSize: 3, width: '100%' }}>
      <Box mt={4} className='login-heading'>
        Reset Password
      </Box>
      <Box mt={6}>Email ID</Box>
      <Input
        mt={1}
        type='text'
        placeholder='Enter your registered email'
        className='login-input'
        value={email}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
      />
      {showError && (
        <Box
          className='error-text'
          mt={2}
          sx={{
            color: '#e34935',
            display: 'flex',
            gap: '5px',
            alignItems: 'center',
            fontSize: '12px',
            fontFamily: 'Medium Sans'
          }}
        >
          <span
            className='material-symbols-outlined'
            style={{ fontSize: '18px' }}
          >
            info
          </span>
          Please enter a valid email address.
        </Box>
      )}
      <button className='login-button' onClick={handleResetClick} id='forgot-password-button'>
        {isLoading ? <ClipLoader color='#fcfcfc' /> : 'Request Reset Link'}
      </button>

      <div
        style={{
          color: 'var(--Color-Accent-Shade-1, #5095FC)',
          textAlign: 'center',
          fontFamily: "Semi Sans",
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: '600',
          lineHeight: '150%',
          textDecorationLine: 'underline',
          cursor: 'pointer'
        }}
        onClick={() => dispatch(setLoginChildPageName('emailPasswordHomePage'))}
      >
        Go back to Sign in
      </div>
    </Box>
  );
};

export default ResetPassword;
